import NamedDto from 'modules/base/dto/NamedDto';

export class EdtDynamicCheckVariableEditDto extends NamedDto {
    constructor() {
        super();

        /** @type {string} */
        this.itemId = null;

        /** @type {string} */
        this.value = null;

        /** @type {number} */
        this.sigma = null;
    }

    /**
     * @typedef {Object} _EdtDynamicCheckVariableEditDtoProps
     * @property {string} itemId
     * @property {string} value
     * @property {number} sigma
     *
     * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _EdtDynamicCheckVariableEditDtoProps} EdtDynamicCheckVariableEditDtoProps
     */
    /**
     *
     * @param {EdtDynamicCheckVariableEditDtoProps} props
     * @returns {EdtDynamicCheckVariableEditDto}
     */
    setup(props) {
        super.setup(props);

        this.itemId = props.itemId;
        this.value = props.value;
        this.sigma = props.sigma;

        return this;
    }
}

export default EdtDynamicCheckVariableEditDto;